import React, { useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { PurchaseOrderDetailProducts } from "./PurchaseOrderDetailProducts";
import { PurchaseOrderDetailServices } from "./PurchaseOrderDetailServices";
import { PurchaseOrderDetailPaymentOffsets } from "./PurchaseOrderDetailPaymentOffsets";
import { PurchaseOrderDetailMain } from "./PurchaseOrderDetailMain";
import { PurchaseOrderDetailAdditional } from "./PurchaseOrderDetailAdditional";
import { PurchaseOrderDetailFooter } from "./PurchaseOrderDetailFooter";
import { IPurchaseOrderDto } from "../dtos/IPurchaseOrderDto";
import { NewDocumentModalViewContext } from "src/components/Shared/NewDocumentModalView";
import handleFormSubmit, { DocumentSaveActionType } from "src/helpers/DocumentHelper";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import { NFSecondTab } from "src/components//Shared/NewForms/NFSecondTab";
import { AppEntities } from "src/config/entities";
import { importFromExcel, saveObjectToExcel } from "src/helpers/SaveObjectToExcel";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "src/components/Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "src/components/Shared/DetailViews/DetailViewToolbarMoreActions";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { IPurchaseOrderModel } from "../models/IPurchaseOrderModel";
import { useFetchPurchaseOrder } from "../hooks/fetchDocument";
import { NFLoadPanel } from "../../../../../Shared/NFLoadPanel";
import { TypeHelper } from "../../../../../../helpers/TypeHelper";

interface IProps {
  id?: string;
}

export const PurchaseOrderDetail = ({ id }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<IPurchaseOrderModel>({
    mode: "onTouched"
  });

  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("");

  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchPurchaseOrder({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };

  // useEffect(() => {
  //     // console.log("formState errors");
  //     if (Object.keys(formState.errors).length != 0) {
  //         console.log("formState.errors", formState);
  //         toast.error("Please fill required fields");
  //     }
  // }, [formState]);

  // const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: IPurchaseOrderModel) => {
  //     console.log("handleFormSubmitLocal");
  //     await handleFormSubmit(action, data, model, saveHandler, postHandler);
  // };

  // if (!model) {
  //     return (
  //         <>
  //             {/*<PurchaseOrdersDetailSkeleton />*/}
  //         </>
  //     );
  // }

  // const exportToExcel = () => {
  //     const data = {
  //         ...model
  //     };
  //     const documentInfo = {
  //         title: AppEntities.PurchaseOrders.title,
  //         number: model.documentNumber,
  //         date: model.documentDate
  //     };
  //     saveObjectToExcel(data, documentInfo);
  // };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFSecondTab title={"Main"} />
          <NFSecondTab title={"Products"} />
          <NFSecondTab title={"Services"} />
          <NFSecondTab title={"Payment offset"} />
          <NFSecondTab title={"Additional"} />
        </NFTabs>

        <div className={"modal-container-height"}>
          <DocumentDetailViewToolbar>
            <DetailViewPostButton onPost={handlePost} />
            <DetailViewCancelButton onCancel={handleCancel} />
            {/*<DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel}*/}
            {/*                              fileName={fileName} setFileName={setFileName}/>*/}
          </DocumentDetailViewToolbar>

          <NFTabContainer index={0} currentIndex={tabIndex}>
            <PurchaseOrderDetailMain />
          </NFTabContainer>

          <NFTabContainer index={1} currentIndex={tabIndex}>
            <PurchaseOrderDetailProducts />
          </NFTabContainer>

          <NFTabContainer index={2} currentIndex={tabIndex}>
            <PurchaseOrderDetailServices />
          </NFTabContainer>

          <NFTabContainer index={3} currentIndex={tabIndex}>
            <PurchaseOrderDetailPaymentOffsets />
          </NFTabContainer>

          <NFTabContainer index={4} currentIndex={tabIndex}>
            <PurchaseOrderDetailAdditional />
          </NFTabContainer>
        </div>
        <PurchaseOrderDetailFooter />
      </FormProvider>
      <NFLoadPanel isLoading={isDocumentLoading} />
    </>
  );
};
